export function nowStamp(): string {
  return new Date().toLocaleTimeString("en-US", { hour12: false });
}

export function parseJsonOrNull<T>(raw: string | null | undefined): T | null {
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

function normalizeBlobPart(data: BlobPart | ArrayBufferView<ArrayBufferLike>): BlobPart {
  if (ArrayBuffer.isView(data)) {
    return data as unknown as BlobPart;
  }

  return data;
}

export function downloadBlob(
  data: BlobPart | ArrayBufferView<ArrayBufferLike>,
  filename: string,
  type: string
): void {
  const blob = new Blob([normalizeBlobPart(data)], { type });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
